// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ursyR","left":"styles_left__2-Bfg"};